import { SVGProps, Ref, forwardRef } from 'react';

export const StarCircleOutlinedSize32Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={32} height={32} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                d="m11.435 17.614-.437-.392c-2.16-1.937-3.239-2.905-2.952-3.827s1.704-1.042 4.54-1.282l.602-.05.244-.612c1.094-2.745 1.64-4.118 2.568-4.118s1.475 1.373 2.569 4.118l.243.611.603.051c2.835.24 4.253.36 4.54 1.282s-.793 1.89-2.952 3.827l-.467.418.136.596c.658 2.893.987 4.34.237 4.91s-1.965-.204-4.393-1.753l-.534-.34-.533.34c-2.428 1.549-3.642 2.323-4.393 1.753s-.421-2.017.237-4.91z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M16 1.333C5 1.333 1.334 8.667 1.334 16S5 30.667 16 30.667 30.667 23.333 30.667 16 27 1.333 16 1.333m-9.614 6.12C4.566 9.637 3.733 12.69 3.733 16s.833 6.363 2.653 8.547c1.755 2.107 4.691 3.72 9.614 3.72s7.859-1.613 9.615-3.72c1.82-2.184 2.652-5.237 2.652-8.547s-.832-6.363-2.652-8.547c-1.756-2.107-4.692-3.72-9.615-3.72s-7.859 1.613-9.614 3.72"
                fill="currentColor"
            />
        </g>
    </svg>
));
StarCircleOutlinedSize32Glyph.displayName = 'StarCircleOutlinedSize32Glyph';
